let activeRequestSignal: AbortSignal | undefined;

// Legacy request helpers build RequestInit synchronously. Scope RTK's signal only
// around that construction so their public call signatures remain unchanged.
export function withRequestSignal<T>(signal: AbortSignal, request: () => T): T {
  const previousSignal = activeRequestSignal;
  activeRequestSignal = signal;
  try {
    return request();
  } finally {
    activeRequestSignal = previousSignal;
  }
}

export function resolveRequestSignal(abortController?: AbortController) {
  return (
    abortController?.signal ??
    activeRequestSignal ??
    new AbortController().signal
  );
}
